import { Fade } from "react-awesome-reveal";
import { IFellowShipTestimonialData } from "../../exports/interfaces";
import useMobile from "../../hooks/useMobile";
import useTab from "../../hooks/useTab";
import { marked } from "marked";

const FellowshipTestimony = (props: {
  testimonials: IFellowShipTestimonialData[];
}) => {
  const mobile = useMobile();
  const tab = useTab();
  return (
    <>
      {props.testimonials.map((testimony, index) => {
        const isEven = index % 2 === 0;

        return (
          <section
            key={index}
            className="welcome-one"
            style={{ padding: "90px 0px 0px 0px" }}
          >
            <div className="container">
              <div className="row">
                <div className="col-xl-12">
                  {/* Use flexbox instead of float */}
                  <div
                    style={{
                      width: "100%",
                      display: !mobile && !tab ? "flex" : "block",
                      flexDirection: isEven ? "row" : "row-reverse",
                      alignItems: "center", // <-- centers vertically
                      gap: "50px", // space between image & text
                    }}
                  >
                    {/* Image */}
                    <Fade
                      cascade
                      damping={0.2}
                      direction={isEven ? "left" : "right"}
                      triggerOnce={true}
                    >
                      <div className="welcome-one__img">
                        <img
                          src={testimony?.attributes?.Image?.data?.attributes?.url && `${process.env.REACT_APP_strapiUrl}${testimony?.attributes?.Image?.data?.attributes?.url}`}
                          alt="welcome-image"
                          style={{
                            objectFit: "cover",
                            width: "250px",
                            height: "250px",
                            objectPosition: "top",
                          }}
                        />
                        <div className="mt-2">
                          <h3
                            className="custom-image-name"
                            style={{ width: "250px" }}
                          >
                            {testimony?.attributes?.Full_Name}
                          </h3>
                          <p style={{ marginBottom: "unset", width: "250px" }}>
                            {testimony?.attributes?.Credentials}
                          </p>
                          <p style={{ marginBottom: "unset", width: "250px" }}>
                            {testimony?.attributes?.Year_Of_Fellowship}
                          </p>
                        </div>
                      </div>
                    </Fade>

                    {/* Text */}
                    <div
                      className="welcome-one__text-2"
                      style={{
                        textAlign: "justify",
                        paddingBottom: "unset",
                        flex: 1,
                      }}
                      dangerouslySetInnerHTML={{
                        __html: marked(
                          testimony?.attributes?.Testimony || ""
                        ) as string,
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
        );
      })}
    </>
  );
};

export default FellowshipTestimony;
